import { css, Theme, SerializedStyles } from "@emotion/react"

export const iconCss = css`
	color: #00050a;
	display: flex;
	padding: 8px;
	padding-top: 6px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-shrink: 0;
	border-radius: 0;

	border-top: none;
	border-bottom: none;
	border-right: 0.5px solid #66696c;

	& svg {
		width: 1.2rem;
		height: 1.2rem;
		color: #00050a;
	}
`

export const autocompleteStyle = (theme: Theme): SerializedStyles => css`
	background: white;
	padding-bottom: 10px;
	border-radius: 0;
	width: 512px;
	height: 40px;
	border-radius: 0.5em;

	${theme.breakpoints.down("xs")} {
		width: 100%;
		margin-top: 10px;
	}

	${theme.breakpoints.down("sm")} {
		width: 100%;
	}

	.MuiAutocomplete-inputRoot {
		padding-right: 0;
		padding-left: 1em;

		.MuiAutocomplete-input {
			border-radius: 0;
			padding: 7px 10px;
		}
	}
`

export const optionImageStyle = css`
	max-height: 3em;
	margin-right: 0.5em;
	img {
		width: unset;
		max-height: 3em;
	}
`

export const DialogContentStyle = css`
	padding: 0;
	margin-bottom: 2.5rem;
`

export const DialogTitleStyle = (theme: Theme): SerializedStyles => css`
	padding: 0 0 1.5rem;
	h2 {
		text-transform: none;
		font-size: 1.5rem;
		${theme.breakpoints.down("xs")} {
			font-size: 1.25rem;
		}
	}
`

export const DialogButtonStyle = (theme: Theme): SerializedStyles => css`
	min-width: 180px;
	width: 100%;
	${theme.breakpoints.down("xs")} {
		min-width: auto;
		padding: 1em 0.75rem;
	}
`
export const DialogBodyStyle = css`
	max-width: 600px;
	box-sizing: border-box;
	padding: 2rem;
`

export const logoLinkStyle = css`
	padding-top: 4px;
`

export const mobileNavButtonStyle = css`
	margin-bottom: 5px;
	width: 36px;
	height: 36px;
	margin-left: -8px;
	margin-right: 4px;

	span {
		margin-top: 2px;
	}

	&:focus {
		outline: 2px solid #fff;
	}
`

export const shopBarSearchStyle = css`
	padding-left: 10em;
`

export const shopBarContainerStyle = css`
	background-color: #f2f2f3;
	color: black;
	width: 100%;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
	position: relative;
	padding-top: 2px;

	& * {
		color: black;
	}
`

export const outerContainerStyle = (theme: Theme) => css`
	background: ${theme.palette.primary.main};
	padding-top: 16px;
	padding-bottom: 16px;
	${theme.breakpoints.down("sm")} {
		padding-top: 12px;
	}
`
